/*
	Zoom plugin for jQuery
	Copyright (c) Inovadora Sistemas
	License proprietary - Inovadora Sistemas
	Author: Mateus Henrique Calza
	Version: 1.0
*/


(function($){

	// Seta a funcionalidade de zoom $("#meuelemento").zoom('+', {max: 2, diff: 0.2})
	$.fn.zoom = function (zoom, options) {
		var mode = options && options.mode && options.mode == 'scale' ? 'scale' : 'zoom';
		var actual = parseFloat($(this).data('zoom') ? $(this).data('zoom') : 1),
			objective,
			// Configurações iniciais (são extendidas pelo segundo parâmetro)
			settings = $.extend({
				diff: ('zoom' in document.body.style && mode != 'scale') ? 0.10 : 0.05,
				min: 0.1,
				max: 3,
				mode: 'zoom' // ou para scale mudar nas options
			}, options),
			css;

		// Adiciona mais zoom
		if(zoom.toString().trim() == '+'){
			objective = actual + settings.diff;
		}
		// Retira zoom
		else if(zoom.toString().trim() == '-'){
			objective = actual - settings.diff;
		}
		// Seta um zoom
		else {
			objective = parseFloat(zoom);
		}

		// Limita o zoom pelas options
		objective = Math.min(settings.max, Math.max(settings.min, objective));

		// Resolução quando o browser suporta CSS zoom (como IE ou Chrome)
		if('zoom' in document.body.style && mode != 'scale'){
			css = {
				'-webkit-zoom': objective,
				'-ms-zoom': objective,
				'zoom': objective
			};
		}
		// Resolução quando o browser NÃO suporta CSS zoom (como FF e Opera)
		else {
			var size = {
				width: $(this).outerWidth(),
				height: $(this).outerWidth()
			};

			// Limita até um zoom que não cause distorções no FF
			objective = Math.min(1.5, Math.max(0.64, objective));

			if (objective >= 1) {
				css = {
					'-webkit-transform': 'scale(' + objective + ', ' + objective + ')',
					'-moz-transform': 'scale(' + objective + ', ' + objective + ')',
					'-ms-transform': 'scale(' + objective + ', ' + objective + ')',
					'-o-transform': 'scale(' + objective + ', ' + objective + ')',
					'transform': 'scale(' + objective + ', ' + objective + ')',
					marginLeft: (size.width * objective - size.width) / 2,
					marginRight: (size.width * objective - size.width) / 2,
					marginTop: (size.height * objective - size.height) / 2,
					marginBottom: (size.height * objective - size.height) / 2
				};
			} else {
				css = {
					'-webkit-transform': 'scale(' + objective + ', ' + objective + ')',
					'-moz-transform': 'scale(' + objective + ', ' + objective + ')',
					'-ms-transform': 'scale(' + objective + ', ' + objective + ')',
					'-o-transform': 'scale(' + objective + ', ' + objective + ')',
					'transform': 'scale(' + objective + ', ' + objective + ')',
					marginLeft: (size.width * objective - size.width) / 2,
					marginRight: (size.width * objective - size.width) / 2,
					marginTop: (size.height * objective - size.height) / 5,
					marginBottom: (size.height * objective - size.height) / 2
				};
			}
		}
		// Salva o zoom, seta o CSS e dispara evento de zoom
		$(this).data('zoom', objective).css(css).trigger('zoom', objective);
	};

})(jQuery);
